/** Contrato vinculado a uma proposta de carregador veicular. */
export type ContratoCarregadorResumo = {
  id: string;
  proposta_id: string;
  contrato_pdf_url?: string | null;
  status?: string | null;
  created_at?: string | null;
};

/**
 * Escolhe o contrato que deve representar a proposta na UI:
 * prioriza o mais recente que já tem PDF; senão, o registro mais recente.
 */
export function getContratoPrincipalCarregador(
  contratos?: ContratoCarregadorResumo[] | null
): ContratoCarregadorResumo | undefined {
  if (!contratos?.length) return undefined;

  const ordenados = [...contratos].sort((a, b) => {
    const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
    const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
    return tb - ta;
  });

  return ordenados.find((c) => Boolean(c.contrato_pdf_url)) ?? ordenados[0];
}

/** Anexa à proposta apenas o contrato principal (evita rascunhos antigos na posição [0]). */
export function anexarContratoPrincipalCarregador<T extends { id: string }>(
  proposta: T,
  contratos: ContratoCarregadorResumo[]
): T & { contratos_carregadores: ContratoCarregadorResumo[] } {
  const daProposta = contratos.filter((c) => c.proposta_id === proposta.id);
  const principal = getContratoPrincipalCarregador(daProposta);
  return {
    ...proposta,
    contratos_carregadores: principal ? [principal] : [],
  };
}
